const MAX_TOTAL_BYTES = 20 * 1024 * 1024;

export function formatAttachmentSize(bytes: number): string {
    if (bytes < 1024) {
        return `${bytes} B`;
    }
    if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(1)} KB`;
    }
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

export function totalAttachmentSize(
    attachments: Array<{size: number}> | undefined,
): number {
    return (attachments ?? []).reduce((sum, item) => sum + item.size, 0);
}

export function remainingAttachmentBytes(
    attachments: Array<{size: number}> | undefined,
): number {
    return Math.max(0, MAX_TOTAL_BYTES - totalAttachmentSize(attachments));
}

export {MAX_TOTAL_BYTES};
